import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Subscription} from "../subscription.model";
import {LocalizedDatePipe} from "@myshared/localized-date.pipe";

@Component({
    selector: 'app-subscription-one-downgrade-cu',
    templateUrl: './subscription-one-downgrade-cu.component.html',
    providers: [LocalizedDatePipe],
    standalone: false
})
export class SubscriptionOneDowngradeCuComponent {
  @Input() subscription: Subscription;
  @Input() public historyBack = true;
  @Input() public backLabel = 'app_back';
  @Input() public selectedCus;

  @Output() public readonly backEvent = new EventEmitter();
  @Output() public readonly next = new EventEmitter();

  public checked = false;

  constructor(private datePipe: LocalizedDatePipe) {
  }

  onNext() {
    if (this.checked) {
      this.next.emit();
    }
  }

  public onBack() {
    this.backEvent.emit();
  }

  public doCheck(checked: boolean) {
    this.checked = checked;
  }
}
